
// src/actions/divisions.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'
import { getArray } from '../helpers/store'

export const FETCH_DIVISIONS = "FETCH_DIVISIONS"
export const FETCH_DIVISIONS_REQUESTED = "FETCH_DIVISIONS_REQUESTED"
export const FETCH_DIVISIONS_COMPLETED = "FETCH_DIVISIONS_COMPLETED"
export const FETCH_DIVISIONS_FAILED = "FETCH_DIVISIONS_FAILED"
export const SET_CURRENT_ID = "SET_CURRENT_ID"
export const SET_CURRENT_DIVISION = "SET_CURRENT_DIVISION"

export const UPDATE_DIVISION_COMPLETED = "UPDATE_DIVISION_COMPLETED"

export function fetchDivisionsRequested() {
  return {
    type: FETCH_DIVISIONS_REQUESTED
  }
}


export function fetchDivisionsCompleted(results) {
  return {
    type: FETCH_DIVISIONS_COMPLETED,
    results,
  }
}
export function fetchDivisionsFailed(error) {
  return {
    type: FETCH_DIVISIONS_FAILED,
    error,
  }
}
export function setCurrentDivisionId(currentId) {
  return {
    type: SET_CURRENT_ID,
    currentId: currentId === 'new' ? 0 : parseInt(currentId),
  }
}
export function setCurrentDivision(currentDivision) {
  return {
    type: SET_CURRENT_DIVISION,
    currentDivision,
  }
}

export function fetchDivisions() {
  return function(dispatch) {
    dispatch(fetchDivisionsRequested())
    return api.get(`/divisions`)
        .then((results)=> {
          dispatch(fetchDivisionsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchDivisionsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function reloadDivision(results) {
  return {
    type: UPDATE_DIVISION_COMPLETED,
    results
  }
}

export const UPDATE_DIVISION_GROUP_REQUESTED = "UPDATE_DIVISION_GROUP_REQUESTED"
export const UPDATE_DIVISION_GROUP_COMPLETED = "UPDATE_DIVISION_GROUP_COMPLETED"
export const UPDATE_DIVISION_GROUP_FAILED = "UPDATE_DIVISION_GROUP_FAILED"

export function updateDivisionGroupRequested() {
  return {
    type: UPDATE_DIVISION_GROUP_REQUESTED
  }
}

export function updateDivisionGroupCompleted(results) {
  return {
    type: UPDATE_DIVISION_GROUP_COMPLETED,
    results,
  }
}

export function updateDivisionGroupFailed(error) {
  return {
    type: UPDATE_DIVISION_GROUP_FAILED,
    error,
  }
}

export function updateDivisionGroup(division_id, group_id, membership = 'add') { // 'add', 'remove'
  return function(dispatch) {
    dispatch(updateDivisionGroupRequested())
    return api.put(`/division_groups/${division_id}/groups/${group_id}`, { membership })
        .then((results)=> {
          dispatch(updateDivisionGroupCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateDivisionGroupFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export const DELETE_DIVISION_REQUESTED = "DELETE_DIVISION_REQUESTED"
export const DELETE_DIVISION_COMPLETED = "DELETE_DIVISION_COMPLETED"
export const DELETE_DIVISION_FAILED = "DELETE_DIVISION_FAILED"

export function deleteDivisionRequested() {
  return {
    type: DELETE_DIVISION_REQUESTED
  }
}

export function deleteDivision(group_id) {
  return function(dispatch) {
    dispatch(deleteDivisionRequested())
    return api.delete(`/divisions/${group_id}`)
        .then((results)=> {
          dispatch(deleteDivisionCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteDivisionFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteDivisionCompleted(results) {
  return {
    type: DELETE_DIVISION_COMPLETED,
    results,
  }
}

export function deleteDivisionFailed(error) {
  return {
    type: DELETE_DIVISION_FAILED,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/actions/divisions.js